export const REQUEST_RECEIPTS_ADMIN = 'Reciepts/REQUEST_RECEIPTS_ADMIN';
export const RECEIVE_RECEIPTS_SUCCESS_ADMIN =
  'Reciepts/RECEIVE_RECEIPTS_SUCCESS_ADMIN';
export const RECEIVE_RECEIPTS_ERROR_ADMIN =
  'Reciepts/RECEIVE_RECEIPTS_ERROR_ADMIN';
